<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>Pasirinkite sutarties rūšį</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 py-4">
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12">
                <el-radio-group
                  required
                  class="my-0"
                  label="sutartis rusis"
                  :items="items"
                  v-model="sutartisRusis"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native="cancelData()">
          Atšaukti
        </el-button>
        <el-button primary @click.native.stop="saveData()">
          Tęsti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalSutartisRusis',
  props: {
    title: String,
    text: String,
    action: String,
    value: Boolean,
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      sutartisRusis: null,
    }
  },
  computed: {
    showTitle() {
      return this.title
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    modalAction() {
      return 'SutartisRusis'
    },
    items() {
      return [
        {
          value: 'sutartis-atpirkimas-teikimas',
          label: 'Pirkimo - pardavimo su atpirkimo teise sutartis',
          tooltip:
            'Savitarna. Teikimas. Pirkimo - pardavimo su atpirkimo teise sutartis',
        },
        {
          value: 'sutartis-issimoketinas-teikimas',
          label: 'Pirkimo - pardavimo išsimokėtinai sutartis',
          tooltip:
            'Savitarna. Teikimas. Pirkimo - pardavimo išsimokėtinai sutartis',
        },
        {
          value: 'sutartis-lizingas-teikimas',
          label: 'Lizingo (finansinės nuomos) sutartis',
          tooltip: 'Savitarna. Teikimas. Lizingo sutartis',
        },
        {
          value: 'sutartis-nuoma-teikimas',
          label: 'Neregistruojamų daiktų nuomos sutartis',
          tooltip:
            'Savitarna. Teikimas. Neregistruojamų daiktų nuomos sutartis',
        },
        {
          value: 'sutartis-panauda-teikimas',
          label: 'Neregistruojamų daiktų panaudos sutartis',
          tooltip:
            'Savitarna. Teikimas. Neregistruojamų daiktų panaudos sutartis',
        },
      ]
    },
  },
  methods: {
    saveData() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.$emit('confirm' + this.modalAction, this.sutartisRusis)
          this.closeModal()
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    cancelData() {
      this.$emit('cancel' + this.modalAction)
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
